// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"bb51a522","225":"514aa9a4","743":"ba8cfc65"}[chunkId] + ".chunk.js";
};